<template>
  <div class="xer-mb-6">
    <div
      class="xer-flex xer-mb-4"
      data-automation-id="collapsable__header"
      @click="collapsableIsOpen = !collapsableIsOpen"
    >
      <slot name="header"></slot>
      <xer-icon v-if="collapsableIsOpen" xer-name="chevron-up" class="xer-ml-3" />
      <xer-icon v-else xer-name="chevron-down" class="xer-ml-3" />
    </div>
    <div v-if="collapsableIsOpen">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XerCollapsable',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      collapsableIsOpen: false
    };
  },
  isOpen(newValue) {
    this.collapsableIsOpen = newValue;
  },
  mounted() {
    this.collapsableIsOpen = this.isOpen;
  }
};
</script>
<style lang="scss">
.collapsable {
  margin-bottom: 15px;
}
.collapsable__arrow {
  margin-left: 1em;
}

.collapsable__arrow--down {
  transform: rotate(90deg);
}

.collapsable__arrow--up {
  transform: rotate(270deg);
}
.collapsable__header {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
</style>
